import ColorCircle from './ColorCircle';

export default ColorCircle;
